const STORAGE_KEY = "a2z_guest_selection";

const toCount = (value, fallback = 0) => {
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : fallback;
};

export const defaultGuestSelection = {
  adults: 2,
  children: 0,
  infants: 0,
  pets: 0,
};

export const getStoredGuests = () => {
  try {
    if (typeof window === "undefined") return null;
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      adults: toCount(parsed.adults, defaultGuestSelection.adults),
      children: toCount(parsed.children, 0),
      infants: toCount(parsed.infants, 0),
      pets: toCount(parsed.pets, 0),
    };
  } catch {
    return null;
  }
};

export const setStoredGuests = (partial = {}) => {
  try {
    if (typeof window === "undefined") return;
    const current = getStoredGuests() || defaultGuestSelection;
    const next = {
      adults:
        partial.adults != null
          ? toCount(partial.adults, current.adults)
          : current.adults,
      children:
        partial.children != null
          ? toCount(partial.children, current.children)
          : current.children,
      infants:
        partial.infants != null
          ? toCount(partial.infants, current.infants)
          : current.infants,
      pets:
        partial.pets != null ? toCount(partial.pets, current.pets) : current.pets,
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Ignore quota / private-mode failures
  }
};

export const parseVillaFormData = (search) => {
  try {
    if (!search) return null;
    const params = new URLSearchParams(
      search.startsWith("?") ? search.slice(1) : search
    );
    const raw = params.get("formData");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const resolveGuests = (formData) => {
  const stored = getStoredGuests();
  if (stored) return stored;
  return {
    adults: toCount(formData?.adults, defaultGuestSelection.adults),
    children: toCount(formData?.children, 0),
    infants: toCount(formData?.infants, 0),
    pets: toCount(formData?.pets, 0),
  };
};
